import React, { useLayoutEffect } from 'react'
import { makeStyles } from '@material-ui/core'
import * as am5 from '@amcharts/amcharts5'
import * as am5radar from '@amcharts/amcharts5/radar'
import { Theme as am5themes_Responsive } from '@amcharts/amcharts5'
import * as am5xy from '@amcharts/amcharts5/xy'
import downGreen from '../../assets/images/downGreen.svg'
import upRed from '../../assets/images/upRed.svg'

const ScenarioAmChart = ({
  idChart = 'chartdiv',
  valueCms,
  colorActive = null,
  title,
  valueOld = null,
  valueRating = '',
}) => {
  let valueEqual = parseFloat(valueCms) - parseFloat(valueOld)
  let colorActiveNew = valueEqual > 0 ? '#FB2F32' : '#00BD58'

  useLayoutEffect(() => {
    // Create root element
    let root = am5.Root.new(idChart)

    // Set themes
    root.setThemes([
      // am5themes_Animated.new(root)
      am5themes_Responsive.new(root),
    ])

    // Create chart
    let chart = root.container.children.push(
      am5radar.RadarChart.new(root, {
        panX: false,
        panY: false,
        startAngle: 130,
        endAngle: 410,
        radius: am5.percent(90),
        layout: root.verticalLayout,
      }),
    )

    // Measurement 1 #
    let axisRenderer = am5radar.AxisRendererCircular.new(root, {
      innerRadius: -18,
    })

    axisRenderer.grid.template.setAll({
      stroke: root.interfaceColors.get('background'),
      visible: true,
      strokeOpacity: 0.8,
    })

    axisRenderer.labels.template.set('forceHidden', true)
    axisRenderer.grid.template.set('forceHidden', true)

    let xAxis = chart.xAxes.push(
      am5xy.ValueAxis.new(root, {
        // maxDeviation: 0,
        min: 0,
        max: 100,
        // strictMinMax: true,
        renderer: axisRenderer,
      }),
    )

    // Create axis ranges bands
    let bandsData = []
    if (valueCms) {
      bandsData = [
        {
          title: 'Unsustainable',
          color: colorActive ?? colorActiveNew,
          lowScore: 0,
          highScore: parseInt(valueCms),
        },
        {
          title: 'No data',
          color: '#DFE4EB',
          lowScore: parseInt(valueCms),
          highScore: 100,
        },
      ]
    } else {
      bandsData = [
        {
          title: 'No data',
          color: '#DFE4EB',
          lowScore: 0,
          highScore: 100,
        },
      ]
    }

    am5.array.each(bandsData, function (data) {
      let axisRange = xAxis.createAxisRange(xAxis.makeDataItem({}))

      axisRange.setAll({
        value: data.lowScore,
        endValue: data.highScore,
      })

      axisRange.get('axisFill').setAll({
        visible: true,
        fill: am5.color(data.color),
        fillOpacity: 0.8,
      })
    })
    // Measurement #2
    let axisRenderer2 = am5radar.AxisRendererCircular.new(root, {
      radius:
        document.getElementById(idChart)?.offsetWidth > 500
          ? document.getElementById(idChart).offsetWidth /
            (document.getElementById(idChart).offsetWidth * 0.015)
          : document.getElementById(idChart).offsetWidth /
            (document.getElementById(idChart).offsetWidth * 0.015),
      // stroke: '#ffff',
    })

    axisRenderer2.labels.template.set('forceHidden', true)
    axisRenderer2.grid.template.set('forceHidden', true)

    let xAxis2 = chart.xAxes.push(
      am5xy.ValueAxis.new(root, {
        maxDeviation: 0,
        min: 0,
        max: 100,
        strictMinMax: false,
        renderer: axisRenderer2,
      }),
    )

    function createLabel(text, val, tickOpacity) {
      let axisDataItem = xAxis2.makeDataItem({ value: val })
      xAxis2.createAxisRange(axisDataItem)

      axisDataItem.get('tick').setAll({
        forceHidden: false,
        strokeOpacity: tickOpacity,
        length: 5 * tickOpacity,
        visible: true,
        inside: true,
        fillOpacity: 1,
        stroke:
          val <= parseInt(valueCms)
            ? am5.color(colorActive ?? colorActiveNew)
            : am5.color('#cfd7e7'),
      })
    }

    createLabel('', 0, 2)
    createLabel('', 15, 2)
    createLabel('', 30, 2)
    createLabel('', 50, 2)
    createLabel('', 70, 2)
    createLabel('', 85, 2)
    createLabel('', 100, 2)

    for (let i = 0; i < 100; i = i + 2.5) {
      if (![0, 15, 30, 50, 70, 85, 100].includes(i)) {
        createLabel('', i, 1)
      }
    }

    // Make stuff animate on load
    chart.appear(1000, 100)

    // Add clock hand
    let axisDataItem = xAxis.makeDataItem({
      fill: 'red',
      name: 'CURRENT',
    })

    let bullet = axisDataItem.set(
      'bullet',
      am5xy.AxisBullet.new(root, {
        sprite: am5radar.ClockHand.new(root, {
          radius: am5.percent(50),
          innerRadius: 5,
          pinRadius: 12,
          topWidth: 1,
          bottomWidth: 12,
        }),
      }),
    )

    bullet.get('sprite').pin.setAll({
      fill: am5.color(valueCms ? colorActive ?? colorActiveNew : '#cfd7e7'),
      fillOpacity: 1,
    })

    bullet.get('sprite').hand.setAll({
      fill: am5.color(valueCms ? colorActive ?? colorActiveNew : '#cfd7e7'),
      fillOpacity: 0.9,
    })

    // let label = chart.radarContainer.children.push(
    //   am5.Label.new(root, {
    //     fill: am5.color(0xffffff),
    //     centerX: am5.percent(50),
    //     textAlign: 'center',
    //     centerY: am5.percent(50),
    //     fontSize: '14px',
    //   }),
    // )

    // bullet.get('sprite').on('rotation', function () {
    //   label.set('text', valueRating ?? '')
    // })

    xAxis.createAxisRange(axisDataItem)

    axisDataItem.set('value', parseInt(valueCms ?? 0))

    chart.bulletsContainer.set('mask', undefined)

    return () => {
      root.dispose()
    }
  }, [valueCms])

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        id={idChart}
        className={'chart-div'}
        style={{
          width: '100%',
          height: '210px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      />
      <div
        style={{
          position: 'absolute',
          marginTop: 200,
          textAlign: 'center',
        }}
      >
        <div
          style={{
            color: '#8D9CB1',
            fontSize: 12,
            fontWeight: 600,
          }}
        >
          {title}
        </div>
        <div
          style={{
            color: '#181818',
            fontSize: '18px',
            fontWeight: 600,
          }}
        >
          {valueCms ?? '0%'}
        </div>
        {valueOld && valueCms && (
          <div
            style={{
              color: valueEqual > 0 ? '#FB2F32' : '#00BD58',
              fontSize: '12px',
              fontWeight: 600,
            }}
          >
            {title === 'STEP 1' ? (
              <>
                {valueEqual > 0 ? (
                  <img src={upRed} className="icon-up-down" />
                ) : (
                  <img src={downGreen} className="icon-up-down" />
                )}
              </>
            ) : (
              <>
                {valueEqual > 0 ? (
                  <img src={upRed} className="icon-up-down" />
                ) : (
                  <img src={downGreen} className="icon-up-down" />
                )}
              </>
            )}

            {valueEqual > 0
              ? Number(valueEqual).toFixed(2) + '%'
              : Number(valueEqual * -1).toFixed(2) + '%'}
          </div>
        )}
        {!!valueRating && (
            <div
                style={{
                  fontSize: '18px',
                  fontWeight: 600,
                }}
            >
              {valueRating}
            </div>
        )}
      </div>
    </div>
  )
}

export default React.memo(ScenarioAmChart)
